interface Props {
  onClick?: (arg?: any) => void
  title?: string
  children?: React.ReactNode
  className?: string
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  ariaLabel?: string
  showpinner?: boolean | undefined
  classContainer?: string
}

export const Button = ({
  showpinner,
  onClick,
  title,
  type = 'button',
  children,
  className,
  disabled,
  ariaLabel,
}: Props) => {
  return (
    <button
      id={`${title}`}
      disabled={disabled ? disabled : false}
      type={`${type}`}
      className={`${className}`}
      onClick={type === 'submit' ? undefined : onClick}
      aria-label={`${ariaLabel}`}
    >
      <span> {children}</span>
      <span> {title ? title : null}</span>

      {showpinner ? (
        <div
          className="relative left-5 top-0.5 animate-spin inline-block w-5 h-5 border-[3px] border-current border-t-transparent text-blue-200 rounded-full"
          role="status"
          aria-label="loading"
        >
          <span className="sr-only">Loading...</span>
        </div>
      ) : null}
    </button>
  )
}
